<div [style.opacity]="loadingScreen.opacity$ | async" id="loadingDiv">
  <img src="assets/img/logo-with-stroke.png" alt="" />
  <span><strong>{{ loadingScreen.loadingText$ | async }}</strong></span>
</div>
